import { FeaturePayload } from '../shared'

/**
 * @description Feature configuruation payload for EMP frontend
 *
 * {@link FeaturePayload}
 */

const featuresConfig: FeaturePayload = {
    CLIENT: { client: 'elavon' },
    _TEST: {
        enabled: true,
    },
    SIGN_IN_LOGO: {
        enabled: false,
        inverted: false,
    },
    SITE_NAME: {
        site_name: 'DisputePro',
        enabled: true,
    },
    MAIN_TOPBAR: {
        LOGO_IMAGE: {
            enabled: true,
        },
        LOGO_TEXT: {
            enabled: false,
            logo_text: 'DisputePro',
            logo_color: undefined,
        },
        PAGE_TITLE: {
            enabled: false,
        },
        TEXT_TITLE: {
            enabled: false,
            text_title: '',
        },
    },
    MAIN_SIDEBAR: {
        enabled: true,
        client_theme_active: true,
        MERCHANT_NAME: {
            enabled: false,
        },
        NAV_SELECTION_UI: {
            type: 'box',
        },
    },
    MAIN_FOOTER: {
        client_name: 'DisputePro',
        enabled: true,
        positionRight: false,
        // footerTitle: 'Powered by Chargebacks911 | Privacy Policy', // Use for cb911 clients
        footerTitle: '',
    },
    MERCHANT_SWITCHER: {
        enabled: true,
        MERCHANT_LIST: {
            enabled_merchant_alias: true,
        },
    },
    DASHBOARD: {
        METRICS: {
            enabled: true,
            metric_variant: 'issuer',
        },
        CHARTS: {
            enabled: true,
            pie_chart: {
                variant: 'chargebacksByCardType',
                title: 'Card Type',
            },
        },
    },
    MERCHANT_HIERARCHY: {
        SELECT_SEARCH_TYPE: {
            enabled: false,
        },
        MERCHANT_ALIAS: {
            enabled: true,
            input_edit_label: 'Company ID',
        },
        MERCHANT_EDIT: {
            enabled: true,
            input_edit_label: 'Enterprise Company ID',
        },
        MERCHANT_UPDATE: {
            enabled: true,
            input_edit_label: 'Enterprise Company ID',
        },
        MID_DETAILS: {
            enabled: true,
            input_edit_label: 'Affiliated ID',
        },
        MID_DETAILS_ID: {
            enabled: true,
            input_edit_label: 'MID / TD ID',
        },
        MID_UPDATE: {
            enabled: true,
            input_edit_label: 'Affiliated ID',
        },
        INHERIT_MERCHANT_SETTING: {
            enabled: true,
        },
        MERCHANT_SERVICE_LEVELS: {
            basic_service_enabled: true,
            pro_service_enabled: true,
            full_service_enabled: false,
        },
        DEFLECTORS: {
            enabled: true,
        },
        SHOW_HELIX_MID: {
            enabled: true,
            input_edit_label: 'MID / TD ID',
        },
        SHOW_MIDS_WPG_FIELD: {
            enabled: false,
        },
        SHOW_MID_HISTORY: {
            enabled: true,
        },
        SHOW_ISSUER_DOC_TOGGLE: {
            enabled: true,
        },
    },
    CHARGEBACKS: {
        enabled: true,
        form_field_variant: 'elavon',
        HELP_LINK: {
            enabled: false,
            text: '',
            url: '',
        },
        DATA_GRID: {
            EDIT_CHARGEBACKS_BUTTON: {
                edit_verdict_only: false,
                disable_status_groups: [],
            },
            CONTEXT_MENU: {
                enabled: true,
            },
        },
        CHARGEBACK_EXPORT_HEADERS: {
            enabled: true,
            headers: [
                { accessor: 'merchant_name', label: undefined },
                { accessor: 'date_due', label: undefined },
                { accessor: 'verdict', label: undefined },
                { accessor: 'id', label: undefined },
                { accessor: 'case_no', label: undefined },
                { accessor: 'order_id', label: undefined },
                { accessor: 'processor', label: undefined },
                { accessor: 'cycle', label: undefined },
                { accessor: 'mid', label: undefined },
                { accessor: 'mid_alias', label: undefined },
                { accessor: 'descriptor', label: undefined },
                { accessor: 'cc_type', label: undefined },
                { accessor: 'reason_code', label: undefined },
                { accessor: 'reason_category', label: undefined },
                { accessor: 'date_post', label: undefined },
                { accessor: 'dispute_amt', label: undefined },
                { accessor: 'dispute_currency', label: undefined },
                { accessor: 'date_trans', label: undefined },
                { accessor: 'trans_amt', label: undefined },
                { accessor: 'trans_currency', label: undefined },
                { accessor: 'cc_bin', label: undefined },
                { accessor: 'cc_last_four', label: undefined },
                { accessor: 'status_group', label: undefined },
                { accessor: 'arn', label: undefined },
                { accessor: 'date_completed', label: undefined },
                { accessor: 'partner_company_id', label: undefined },
                { accessor: 'installment_no', label: undefined },
            ],
        },
    },
    CASE_MANAGEMENT: {
        UPGRADE_ALERT: {
            enabled: false,
            roles: [],
        },
        CASE_MANAGEMENT_EXPORT_HEADERS: {
            enabled: false,
            headers: [],
        },
    },
    HELP: {
        ADD_ONS: {
            client_name: 'DisputePro',
            enabled: true,
            topicTitles: [
                'Chargebacks',
                'Case Management',
                'User Management',
                'Profile Settings',
            ],
            videoURLs: {
                chargebacks:
                    'Navigating_Chargebacks_Using_Advanced_Search_-_Unbranded.mp4',
                alerts: '',
                caseManagement: 'Case_Management_Full_-_Unbranded.mp4',
                userManagement: 'user_management_unbranded.mp4',
                profileSettings: 'Managing_Profile_Settings_-_Unbranded.mp4',
                caseBuilder: '',
                ertsFullService: '',
            },
        },
        USER_DOC: {
            client_name: 'DisputePro',
            enabled: true,
            user_guide_link_is_local_file: true,
            user_guide_link: 'cb911-demo.merchant-dispute.com',
        },
    },
    REPORTS: {
        CHARTS: {
            PARTNER_ADMIN: {
                enabled: true,
                default_date_range: {
                    cbByTransMonthPctLine: {
                        enabled: false,
                        value: null,
                    },
                },
                // Each section renders the chart groups into their own divs, from top to bottom.
                // Be cognizant of the order you define chart variants, they render in the order of the chart variant array
                charts_and_position: {
                    section_1: {
                        type: 'card',
                        charts: [
                            'cardTypeDonut',
                            // 'cbByWinLoss',
                            'reasonCodeDistributionDonut',
                            'cbByIssuerPctTop5Donut',
                        ],
                    },
                    section_2: {
                        type: 'grid',
                        charts: [
                            'cbByTransMonthPctLine',
                            'averageSpanCbTransPostDatebyWeekPctLine',
                        ],
                    },
                    section_3: {
                        type: 'grid',
                        charts: [
                            // 'cbByCardTypePerPlatformPctTop5Bar',
                            'cbByTransAmountPctBar',
                            'cbByPlatformPctTop5Bar',
                            'cbByBinPctTop5Bar',
                        ],
                    },
                },
            },
            MERCHANT_ADMIN: {
                enabled: true,
                default_date_range: {
                    cbByTransMonthPctLine: {
                        enabled: false,
                        value: null,
                    },
                },
                charts_and_position: {
                    section_1: {
                        type: 'grid',
                        charts: [
                            'cbByTransMonthPctLine',
                            'cbByTransAmountPctBar',
                            'averageSpanCbTransPostDatebyWeekPctLine',
                        ],
                    },
                    section_2: {
                        type: 'grid',
                        charts: [
                            'cbByCardTypePerPlatformPctTop5Bar',
                            'cbByPlatformPctTop5Bar',
                            'cbByBinPctTop10Bar',
                        ],
                    },
                    section_3: {
                        type: 'card',
                        charts: [
                            'cardTypeDonut',
                            // 'cbByWinLoss',
                            'reasonCodeDistributionDonut',
                        ],
                    },
                },
            },
        },
        FILTERS: {
            ALL_GATEWAY_IDS: {
                enabled: false,
            },
            ALL_PLATFORMS: {
                enabled: false,
            },
        },
    },
    ERT: {
        ADD_ERT: {
            enabled: true,
            roles: ['cb911_admin', 'partner_admin', 'partner_user'],
        },
    },
    CASE_QC_REVIEW: {
        DO_NOT_REPRESENT: {
            enabled: false,
        },
    },
    USERS: {
        READ_ONLY_OPTION: {
            enabled: true,
        },
    },
    ALERTS: {
        AUTO_REFUND_RULES: {
            enabled: true,
        },
    },
    ADVANCED_SEARCH_FILTERS: {
        INVALID_CHARGEBACKS: {
            enabled: true,
            filters: [
                {
                    alias: 'id',
                    alias_override: 'case_id',
                    label: 'Chargeback ID',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'text',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'case_no',
                    alias_override: undefined,
                    label: 'Case Number',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'userDefinedMultiSelect',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'order_id',
                    alias_override: 'trans_id',
                    label: 'Order ID',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'text',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'mid_alias',
                    alias_override: undefined,
                    label: 'Affiliated ID',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'text',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'mid',
                    alias_override: undefined,
                    label: 'MID / TD ID',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'text',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'cycle_id',
                    alias_override: 'cycle',
                    label: 'Cycle',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'select',
                    endpoint: '/cm/gen/cycles',
                    default_options: undefined,
                    is_multiple_choice: true,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'cc_bin',
                    alias_override: undefined,
                    label: 'Card BIN',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'text',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'cc_last_4',
                    alias_override: 'cc_last_four',
                    label: 'Card Last Four',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'text',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'reason_code',
                    alias_override: 'reason_code_id',
                    label: 'Reason Code',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'select',
                    endpoint: 'cm/gen/rc',
                    default_options: undefined,
                    is_multiple_choice: true,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'reason_category',
                    alias_override: undefined,
                    label: 'Reason Category',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'select',
                    endpoint: '/cm/gen/rc-categories',
                    default_options: undefined,
                    is_multiple_choice: true,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'trans_amt',
                    alias_override: undefined,
                    label: 'Transaction Amount',
                    initial_value: '',
                    initial_compare_value: 'eq',
                    type: 'amount',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'dispute_amt',
                    alias_override: 'case_amt',
                    label: 'Dispute Amount',
                    initial_value: '',
                    initial_compare_value: 'eq',
                    type: 'amount',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'currency',
                    alias_override: 'currency_id',
                    label: 'Dispute Currency',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'select',
                    endpoint: '/cm/gen/currencies',
                    default_options: undefined,
                    is_multiple_choice: true,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'card_type',
                    alias_override: undefined,
                    label: 'Card Type',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'select',
                    endpoint: '/cm/gen/cctypes',
                    default_options: undefined,
                    is_multiple_choice: true,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'status_group_id',
                    alias_override: undefined,
                    label: 'Status',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'select',
                    endpoint: '/cm/gen/status-groups',
                    default_options: undefined,
                    is_multiple_choice: true,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'verdict',
                    alias_override: undefined,
                    label: 'Outcome',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'select',
                    endpoint: '/cm/gen/verdicts',
                    default_options: undefined,
                    is_multiple_choice: true,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'arn',
                    alias_override: undefined,
                    label: 'ARN',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'text',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: false,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'trans_date',
                    alias_override: 'trans_date_range',
                    label: 'Transaction Date',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'date',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: true,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'post_date',
                    alias_override: 'date_range_post',
                    label: 'Post Date',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'date',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: true,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'date_due',
                    alias_override: 'due_date_range',
                    label: 'Due Date',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'due-date',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: true,
                    is_enabled: true,
                    roles: [],
                },
                {
                    alias: 'date_completed',
                    alias_override: 'date_completed_range',
                    label: 'Completed Date',
                    initial_value: '',
                    initial_compare_value: undefined,
                    type: 'date',
                    endpoint: undefined,
                    default_options: undefined,
                    is_multiple_choice: false,
                    is_clear_date_icon: true,
                    is_enabled: true,
                    roles: [],
                },
            ],
        },
    },
    DATAGRID: {
        ZEBRA_STRIPED_ROWS: {
            enabled: true,
        },
        ENABLE_OVERFLOW_COLUMNS: {
            enabled: true,
        },
        ENABLE_HEADER_WRAP: {
            enabled: false, // If switching, check column definition widths. Columns might overflow off DataGridSlim.
        },
    },
    ACCENT_AREA: {
        client_theme_top_border: false,
        title_icon: true,
    },
    SEARCH_BAR: {
        enabled: true,
        style: 'outlined',
    },
    FORM_FIELDS: {
        enabled: true,
        style: 'outlined',
    },
    HAS_THEME_VARIATIONS: {
        enabled: true,
    },
    SHOW_AG_SWITCHER: {
        enabled: false,
    },
    ALERTS_IFRAME: {
        enabled: true,
    },
    HAS_REMEDY: {
        enabled: true,
    },
}

export default featuresConfig
